import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import OrgStakeholdersFormContainer from '../../../containers/organizations/OrgStaheholdersFormContainer.jsx';

const NewOrgStakeholders = ({ slug }) => (
  <>
    <Helmet>
      <title>Organization Stakeholders | ChangeSync</title>
    </Helmet>

    <OrgStakeholdersFormContainer slug={slug} />
  </>
);

NewOrgStakeholders.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewOrgStakeholders));
